import React from "react";

const ModernGreenCheckIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8209 20.8215C17.2448 20.8215 21.6418 16.4245 21.6418 11.0006C21.6418 5.57665 17.2448 1.17969 11.8209 1.17969C6.39696 1.17969 2 5.57665 2 11.0006C2 16.4245 6.39696 20.8215 11.8209 20.8215Z"
        fill="#009951"
      />
      <path
        d="M11.8209 7.07222V11.0006M11.8209 14.9289H11.8307M21.6418 11.0006C21.6418 16.4245 17.2448 20.8215 11.8209 20.8215C6.39696 20.8215 2 16.4245 2 11.0006C2 5.57665 6.39696 1.17969 11.8209 1.17969C17.2448 1.17969 21.6418 5.57665 21.6418 11.0006Z"
        stroke="#009951"
        stroke-width="2.12786"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="11.8212" cy="11.0038" r="8.41791" fill="#009951" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0425 8.47437C16.4695 8.86854 16.4961 9.53425 16.1019 9.96127L12.1577 14.2342C11.5921 14.847 10.62 14.834 10.0709 14.2065L7.87267 11.6942C7.48999 11.2568 7.5343 10.5921 7.97165 10.2094C8.409 9.82672 9.07377 9.87103 9.45645 10.3084L11.1407 12.2333L14.5555 8.53384C14.9497 8.10682 15.6154 8.0802 16.0425 8.47437Z"
        fill="url(#paint0_linear_4856_24685)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4856_24685"
          x1="12.3866"
          y1="8.19531"
          x2="19.4063"
          y2="24.4573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#F4F4F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ModernGreenCheckIcon;
